import { useUser } from 'context/UserContext';
import { titler } from 'helpers/titler';
import React from 'react';
import Classroom from './Classroom';
import ClassroomStarter from './ClassroomStarter';

const ClassroomRouter = () => {
  const user = useUser();
  titler('Classe');
  if (user.classroomCode) {
    return <Classroom />;
  } else {
    return <ClassroomStarter />;
  }
};

export default ClassroomRouter;
